import type { RegisseurType, UtilisateurType } from '@/types';

type FormatUtilisateurToRegisseurType = (utilisateur: UtilisateurType) => Partial<RegisseurType>;

export const formatUtilisateurToRegisseur: FormatUtilisateurToRegisseurType = (utilisateur) => ({
  identifiantLogin: utilisateur.identifiant,
  nom: utilisateur.nom,
  prenom: utilisateur.prenom,
  caduque: false,
});

export const getRegieRegisseurFullName = (regisseur: RegisseurType) => {
  if (regisseur) {
    return `${regisseur.prenom ? `${regisseur.prenom} ` : ''}${regisseur.nom || ''}`;
  }

  return '';
};
